import React, {  Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import _ from 'lodash';

import GenericOverlayDialog from '../../dialogs/genericOverlayDialog';
import moment from 'moment';
import { routes } from '../../../redux/api/routes';
import RequestReturnFileWarningDialog from "../../dialogs/requestReturnFileWarningDialog";

/* Actions */
import {
	printRequestOrderDetails,
	getInvoicePDF,
	validateWarehouseCode,
	getFiles
} from '../../../redux/actions';

let { s3BucketAPIBaseURL } = routes;
class ViewReturnOrderDetails extends Component {

	constructor(props) {
		super(props);
		this.state = {
			orderDetails: null,
			backupOrderDetails: null,
			pickingUpByAddress: null,

			showGenericOverlayDialog: false,
			genericDialogHeading: '',
            genericDialogText: '',
            modalButtons: '',
			typeOfOrder: 'return',
			filesInS3:'',
			fileForCurrSerial:[],
			serState:'',
			showNoFile: false,
			showRequestReturnFileWarningDialog:false,
			fileUploaded:false,
		}
		this.formatMoney=this.formatMoney.bind(this);
		this.updateStateWithOrderDetails = this.updateStateWithOrderDetails.bind(this);
		this.handleDialog = this.handleDialog.bind(this);
		this.handleOpenFiles = this.handleOpenFiles.bind(this);
		this.handleFileChange = this.handleFileChange.bind(this);
	}

	// event for close dialog
	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		var self = this,
			accountNumber = self.props.getSelectedAccountNumber();
		if(self.props.state.order.orderDetails && accountNumber) {
			self.updateStateWithOrderDetails(self.props.state.order.orderDetails);
		} else {
			browserHistory.push('/viewRequests');
		}
	}
	formatMoney(n, c, d, t, removeDecimal, currencySymbol) {
        c = Math.abs(c);
        c = isNaN(c) ? 2 : c;
        if(n === 0) n = "0";
        if(!n) return "";
        if(n == "Today's price not available currently."){
            return <span style={{color:"red", fontWeight:"bold"}}>{"Item not priced"}</span>
        }
        n = parseFloat(n.toString().replace(/,/g,''));
    var result =(removeDecimal ? parseFloat(n) :Number(n)).toFixed(c);
    if(currencySymbol) {
        if(result < 0) {
            result = "-" + currencySymbol + result.replace("-", "");
        } else {
            result = currencySymbol + result;
        }
    }
       return result;
 }
	updateStateWithOrderDetails(response) {
		var self = this;
		if(!response.status) {
			self.setState({
				errorMessage: response.responseMessage
			})
		} else {
			// Save backup for handle print service
			self.setState({
				backupOrderDetails: JSON.parse(JSON.stringify(response.responseObject))
			}, () => {
				let typeOfOrder = 'return';
				if(response.responseObject.items.length === response.responseObject.items.filter(item => item.lineType === 'Bill Only Line' || item.lineType === 'Other Credit').length) {
					typeOfOrder = 'credit';
				}
				//Make shipping service call to get picking up by address
				if(response.responseObject.shippingAddress.zip) {
					response.responseObject.shippingAddress = new Array(response.responseObject.shippingAddress);
				}
				if(typeOfOrder === 'return' && response.responseObject.warehouseCode) {
					// make service call to validate warehouse code
					self.props.validateWarehouseCode(`requestType=getWarehouseDetails&warehouseCode=${response.responseObject.warehouseCode}`, resp => {
						if (resp.status && resp.responseObject && resp.responseObject.facilitycoreresponse && resp.responseObject.facilitycoreresponse.length) {
							const data = resp.responseObject.facilitycoreresponse[0];
							self.setState({
								pickingUpByAddress: {
									dockname: data.facilityname ? data.facilityname.value : '',
									dockaddr: data.facilityaddressline1 ? data.facilityaddressline1.value : '',
									dockaddr2: data.facilityaddressline2 ? data.facilityaddressline2.value : '',
									dockaddr3: data.facilityaddressline3 ? data.facilityaddressline3.value : '',
									dockcity: data.facilitycity ? data.facilitycity.value : '',
									dockst: data.facilitystate ? data.facilitystate.value : '',
									dockzip: data.facilityzipcode ? data.facilityzipcode.value : '',
									dockphone: data.facilitylocationphone ? data.facilitylocationphone.value : '',
								}
							});
						} else {
							self.setState({
								errorMessage: 'Invalid warehouse code.'
							});
						}
					});
				}

				//filter all products which cancelled.
				response.responseObject.items = _.filter(response.responseObject.items, (item) => {
					return item.lineStatus !== 'CANCELLED';
				});

				response.responseObject.items.map((item, index) => {
					let extendedPrice = null;
					if(item.price && item.quantity) {
						extendedPrice = parseInt(item.price, 10) * parseInt(item.quantity, 10);
					}
					item.shipSet = item.shipSet?item.shipSet:0
					item.extendedPrice = extendedPrice;
					return null;
				})

				response.responseObject.shippingAddress.map((item, index) => {
					item.items = _.filter(response.responseObject.items, ['shipSet', item.shipSet]);
					item.subTotal = _.sumBy(item.items, 'extendedPrice');
					item.orderTax = _.sumBy(item.items, (itm) => {return parseFloat(itm.tax)}, 'tax');
					item.orderTotal = item.orderTax + item.subTotal;
					item.subPointValue = _.sumBy(item.items, (itm) => {return parseFloat(itm.pointValue)}, 'pointValue');
					return null;
				});
				self.setState({
					orderDetails: response.responseObject,
					typeOfOrder
				});
			});
		}
	}

	handlePrint(event) {
		event.preventDefault();
		const self = this;
		self.setState({
			errorMessage: ''
		});
		let payload = JSON.parse(JSON.stringify(self.state.backupOrderDetails));
		payload.typeOfOrder = self.state.typeOfOrder;
		if(payload.shippingAddress && payload.shippingAddress[0]) {
			payload.shippingAddress = payload.shippingAddress[0];
		}
		if (self.state.typeOfOrder === 'return') {
			payload.pickingUpByAddress = {
				address1: self.state.pickingUpByAddress.dockname,
				address2: self.state.pickingUpByAddress.dockaddr,
				state: self.state.pickingUpByAddress.dockst,
				city: self.state.pickingUpByAddress.dockcity,
				zip: self.state.pickingUpByAddress.dockzip,
				phone: self.props.normalizePhoneNumber(self.state.pickingUpByAddress.dockphone)
			};
		}
		self.props.printRequestOrderDetails(payload, (response) => {
			if(!response.status) {
				self.setState({
					errorMessage: response.responseMessage
				})
			} else {
				window.open(response.responseObject);
			}
		})
	}

	getLineType(ebsLineType) {
		const ebsLineTypeList = [{
			ebsLineType: 'Return Line',
			displayLineType: 'Return'
		}, {
			ebsLineType: 'Standard Line',
			displayLineType: 'Standard'
		}, {
			ebsLineType: 'Other Credit',
			displayLineType: 'Credit'
		}, {
			ebsLineType: 'Bill Only Line',
			displayLineType: 'Bill Only'
		}];
		const data = ebsLineTypeList.find(itm => itm.ebsLineType === ebsLineType);
		return data ? data.displayLineType : '';
	}

	handleOpenFiles (accountNumber, originalOrderNumber, productNumber, ser, typeOfOrder) {
		const self = this;
		const str = ser.includes('-') ? ser.split('-')[0]:ser;
	//	if(self.state.filesInS3.length === 0) {
			self.props.getFiles(`name=CustomerNet/ReturnAndCredit/${typeOfOrder === 'credit'? 'Credits':'Returns'}/${accountNumber}/${originalOrderNumber}/`,response => {
				if(response && response.responseObject && response.status && Object.keys(response.responseObject).length !== 0) {
						const fileAndUrl = [];
							str !== "NA" && response && response.responseObject[str] && response.responseObject[str].length > 0 ? response.responseObject[str].map((item, index) => {
								const filename = originalOrderNumber+'-'+productNumber+'-'+str+'-'+(index+1);
								fileAndUrl.push({ [filename]: item});
								
							}): self.setState({
								showNoFile: true
							});
						self.setState({
							filesInS3 : response.responseObject,
							fileForCurrSerial : fileAndUrl,
							serState:ser
						});
				} else {
					self.setState({
						showNoFile: true
					})
				}
			});
		
	}

	getInvoiceDocument(invoiceNumber, event) {
		event && event.preventDefault();
		const self = this;
		// second param says whether it needs to be saved into store
		const param = `requestType=getInvoicePDF&invoiceNumber=${invoiceNumber}&accountNumber=${self.props.getSelectedAccountNumber()}`;
		self.props.getInvoicePDF(param, response => {
			if(response.status) {
				if(response.responseObject) {
					window.open(response.responseObject);
				} else {
					// No invoice document found
					self.setState({
						genericDialogHeading: "Invoice",
						genericDialogText: "No invoice document found.",
						modalButtons: 'ok'
					}, () => {
						self.handleDialog("GenericOverlayDialog", true);
					});
				}
			} else {
				browserHistory.push('/error');
			}
		});
	}
	handleFileChange(item, serial, index, lineType,  event) {
		const self = this;
		const files = event.target.files;
		if (!self.state.orderDetails.items[index].fileUploadSerialErrors){
			self.state.orderDetails.items[index].fileUploadSerialErrors = new Map();
		}
		if(!self.state.orderDetails.items[index].serialAndUplodedFileList) {
			self.state.orderDetails.items[index].serialAndUplodedFileList = new Map();
		}
		self.state.orderDetails.items[index].serialAndUplodedFileList.get(serial) ? '': 
		self.state.orderDetails.items[index].serialAndUplodedFileList.set(serial, []);
		if(files.length > 0) {
			const allowedTypes = ['image/jpeg', 'image/pjpeg', 'image/gif', 'image/png', 'image/bmp', 'image/x-windows-bmp', 'application/pdf'];
  			const invalidFiles = Array.from(files).filter(file => !allowedTypes.includes(file.type));
			if (invalidFiles.length > 0) {
				self.state.orderDetails.items[index].fileUploadSerialErrors.set(serial, 'Invalid file type. Please select a JGP, PNG or PDF file.');
				this.setState({
					showRequestReturnFileWarningDialog :true
				})
				return;
			}

			for (let i = 0; i < files.length; i++) {
				if(files[i].size/1000 > 5000) {
					self.state.orderDetails.items[index].fileUploadSerialErrors.set(serial, "Please select a file that is not larger than 5 MB");
					this.setState({
						showRequestReturnFileWarningDialog :true
					})
				} else {
					self.state.orderDetails.items[index].fileUploadSerialErrors.set(serial, '');
				}
			}
			if(self.state.orderDetails.items[index].fileUploadSerialErrors.get(serial) === '') {
				this.uploadFiles(files, item, serial, index, lineType);
			}
		}
	};

	uploadFiles = async (files, item, serial, index, lineType) => {
		const self = this;
		const { userDetails } = self.props.state.user;
		const orderDetails = self.state.orderDetails && self.state.orderDetails;
		let lineTypeFinal = lineType == "Return Line"? "Returns":"Credits";
		//const requestReturnDetails = self.state.requestReturnDetails;
		// handle file upload
		const uploadFile = (file) => {
			const existingFileNames = self.state.orderDetails.items[index].serialAndUplodedFileList.get(serial);
			// Append the new file name to the array if it's not already there
			if (!existingFileNames.includes(file.name)) {
				existingFileNames.push(file.name);
			}
			const reader = new FileReader();
			reader.addEventListener('loadend', function (e) {
				fetch(s3BucketAPIBaseURL, {
					method: "POST",
					headers: {
						'Content-Type': 'application/json',
						"Authorization": `${userDetails.jwt}${userDetails.sso}`,
					},
					body: JSON.stringify({
						name:  `CustomerNet/ReturnAndCredit/${lineTypeFinal}/${orderDetails.accountNumber}/${orderDetails.originalOrderNumber}/${orderDetails.originalOrderNumber}-${item}-${serial}-${moment()}`,
						type: file.type
					})
				}).then(function (response) {
					return response.json();
				}).then(function (json) {
					return fetch(json.uploadURL, {
						method: "PUT",
						body: new Blob([reader.result], {
							type: file.type
						})
					})
				}).then(function () {
					self.state.orderDetails.items[index].fileUploadSerialErrors.set(serial, 'File is uploaded successfully.');
					self.state.orderDetails.items[index].serialAndUplodedFileList.set(serial, existingFileNames);
					//self.props.setRequestReturnDetails(requestReturnDetails);
					self.setState({
						showSerialNumberuploadError : false,
						fileUploaded : true
					});
				});
			});

			reader.readAsArrayBuffer(file);
		};

		// Use Promise.all to wait for all uploads to complete
		await Promise.all(Array.from(files).map(uploadFile));

	}


    render() {
		const self = this;
		let { orderDetails, pickingUpByAddress, typeOfOrder } = this.state;
        return (
			<div>
				<p className="textRight d-none d-sm-block">
					<a className="withIcon withPrintIcon noUnderline bold uppercase" onClick={this.handlePrint.bind(this)} href="">Print Return/Credit Details</a>
				</p>
				<div className="push d-none d-sm-block">
					<h1 className="pageTitle">Return/Credit Details</h1>
				</div>
				<div className="push d-block d-sm-none m-3">
					<h1 className="pageTitle">Return/Credit Details</h1>
				</div>
				<div className='d-none d-sm-block'>
					<h2>Return/Credit Order # {orderDetails && orderDetails.orderNumber}</h2>
					<p><b>Account #: {orderDetails && orderDetails.accountNumber}</b></p>
				</div>
				<div className='d-block d-sm-none m-3'>
					<h2>Return/Credit Order # {orderDetails && orderDetails.orderNumber}</h2>
				</div>
				<p className="bold red">{this.state.errorMessage}</p>
				{orderDetails && <div className='d-none d-sm-block'>
					<div className="orderReviewColumns columns threeColumns">
						<div className="orderReviewColumn column column1">
							<p>
								<strong>
									{typeOfOrder === 'credit'
										?"Ship to"
										:(orderDetails.deliveryMethod === "SDS Delivery"
											?"Picking Up from"
											:(orderDetails.deliveryMethod === "SDS Will Call"
												?"Return From"
												:null
											)
										)
									}
								</strong>:<br />
								{orderDetails.shippingAddress[0].addressName && <span>{orderDetails.shippingAddress[0].addressName}<br /></span>}
								<span>{orderDetails.shippingAddress[0].address1}<br /></span>
								{orderDetails.shippingAddress[0].address2 && <span>{orderDetails.shippingAddress[0].address2}<br /></span>}
								<span>{orderDetails.shippingAddress[0].city + ', ' + orderDetails.shippingAddress[0].state + ' ' + orderDetails.shippingAddress[0].zip}<br /></span>
								{orderDetails.shippingAddress[0].phone && <span>{this.props.normalizePhoneNumber(orderDetails.shippingAddress[0].phone)}<br /></span>}
							</p>
							<p>
								<strong>P.O.#:</strong> {orderDetails.poNumber}
							</p>
						</div>
						<div className="orderReviewColumn column column2">
							{orderDetails.billingAddress && <p>
								<strong>Bill to</strong>:<br />
								{orderDetails.billingAddress.addressName && <span>{orderDetails.billingAddress.addressName}<br /></span>}
								<span>{orderDetails.billingAddress.address1}<br /></span>
								<span>{orderDetails.billingAddress.city + ', ' + orderDetails.billingAddress.state + ' ' + orderDetails.billingAddress.zip}<br /></span>
								{orderDetails.billingAddress.phone && <span>{this.props.normalizePhoneNumber(orderDetails.billingAddress.phone)}<br /></span>}
							</p>}
						</div>
						{typeOfOrder === 'return'
							?<div className="orderReviewColumn column column3">
								{pickingUpByAddress && <p>
									<strong>
										{orderDetails.deliveryMethod === "SDS Delivery"
											?"Picking Up by"
											:(orderDetails.deliveryMethod === "SDS Will Call"
												?"Return To"
												:null
											)
										}
									</strong>:<br />
									{pickingUpByAddress.dockname && <span>{pickingUpByAddress.dockname}<br /></span>}
									<span>{pickingUpByAddress.dockaddr}<br /></span>
									{pickingUpByAddress.dockaddr2 && <span>{pickingUpByAddress.dockaddr2}<br /></span>}
									{pickingUpByAddress.dockaddr3 && <span>{pickingUpByAddress.dockaddr3}<br /></span>}
									<span>{pickingUpByAddress.dockcity + ', ' + pickingUpByAddress.dockst + ' ' + pickingUpByAddress.dockzip}<br /></span>
									{pickingUpByAddress.dockphone && <span>{this.props.normalizePhoneNumber(pickingUpByAddress.dockphone)}<br /></span>}
								</p>}
							</div>
							:<div className="orderReviewColumn column column3" />
						}
					</div>
					<div className="orderReviewColumns columns threeColumns">
						<div className="orderReviewColumn column column1">
							<p>
								{orderDetails.createdBy && <span><strong>Entered By:</strong> {orderDetails.createdBy}<br /></span>}
								{orderDetails.orderDate && <span><strong>Entered On:</strong> {this.props.formatDate(orderDetails.orderDate, 'MM/DD/YY')}<br /></span>}
							</p>
						</div>
						<div className="orderReviewColumn column column2">
							<p>
								{orderDetails.deliveryPhone && <span><strong>Phone:</strong> {this.props.normalizePhoneNumber(orderDetails.deliveryPhone)}<br /></span>}
								{typeOfOrder === 'return' && orderDetails.deliveryInstructions && <span><strong>Instructions:</strong> {orderDetails.deliveryInstructions}<br /></span>}
							</p>
						</div>
						<div className="orderReviewColumn column column3" />
					</div>
					<div className="push">
						<h2>Original CSO (Order number): {orderDetails.originalOrderNumber}</h2>
						<table className="dataTable viewReturnsTable">
							<thead>
								<tr className="viperDarkHeader">
									<th className="product">Product</th>
									<th className="quantityToReturn" style={{textAlign: 'center'}}>Qty</th>
									<th className="serialNumbers" style={{textAlign: 'center'}}>Serial(s)</th>
									<th className="serialNumbers" style={{textAlign: 'center'}}>View<br />Photo(s)</th>
									<th className="returnType">Line Type</th>
									<th className="originalInvoiceNumber" style={{textAlign: 'center'}}>Invoice #</th>
									<th className="originalInvoiceNumber" style={{textAlign: 'center'}}>Original<br />Invoice #</th>
									<th className="returnType txt-ctr">Price</th>
									<th className="reasonForReturn">Reason</th>
									<th className="reasonForReturn">Status</th>
								</tr>
							</thead>
							<tbody>
								{orderDetails.items.map((item, index) => {
									let quantity = item.quantity;
									let price = item.price;
									let serialNumber = typeOfOrder === 'credit'? item.userItemDescription: (item.serialNumber || item.userItemDescription);
									if(self.getLineType(item.lineType) === 'Return' || self.getLineType(item.lineType) === 'Credit') {
										quantity *= -1;
										price *= -1;
									}
									return <tr key={index}>
										<td className="product">{item.item}</td>
										<td className="quantityToReturn" style={{textAlign: 'center'}}>{quantity}</td>
										<td>
											<table>
												<tbody>
													{serialNumber && serialNumber.split(' ').map(ser=>{
														return (self.getLineType(item.lineType) === 'Return' || self.getLineType(item.lineType) === 'Credit')? <div><tr> {ser}</tr><br/><br/><br/></div>: <tr>{ser}</tr>}
													)}
												</tbody>
											</table>
										</td>
										<td>
											<table>
												<tbody>
													{serialNumber && serialNumber.split(' ').map(ser=>{
														return <tr>{self.getLineType(item.lineType) === 'Return' || self.getLineType(item.lineType) === 'Credit'? 
																		<div style={{paddingTop:"10%"}}>
																			<div>
																				<input key={index} 
																				style={{ width: "100%", color:"white", backgroundColor:"#1A63A2", padding:"2px", borderColor:"unset" }} 
																				type='button' 
																				value='Open Photo(s)' 
																				onClick={() => this.handleOpenFiles(orderDetails.accountNumber, orderDetails.originalOrderNumber, item.item, ser, typeOfOrder)}/> 
																			</div>
																			<br/>
																			<div>
																				<label style={{padding:"2px 5px 2px 5px", textAlign:"center", textTransform:"none", color:"white", backgroundColor:"#1A63A2"}}>
																				{`Add Photo(s)`}
																					<div style={{display:"none"}}>
																						<input accept="image/jpeg,image/pjpeg,image/gif,image/png,image/bmp,image/x-windows-bmp" type="file" 
																						multiple placeholder='Upload Image' onChange={(event)=>this.handleFileChange(item.item, ser, index, item.lineType, event)} />
																					</div>
																				</label>
																			</div>
																		</div>
																	: null}
																</tr>
													})}
												</tbody>
											</table>
										</td>
										<td className="returnType">{self.getLineType(item.lineType)}</td>
										<td className="originalInvoiceNumber" style={{textAlign: 'center'}}><a href="" onClick={this.getInvoiceDocument.bind(this, item.invoiceNumber)}>{item.invoiceNumber}</a></td>
										<td className="originalInvoiceNumber" style={{textAlign: 'center'}}><a href="" onClick={this.getInvoiceDocument.bind(this, item.originalInvoiceNumber)}>{item.originalInvoiceNumber}</a></td>
										<td className="returnType text-right">{self.formatMoney(price, 2, ".", ",", false, "$")}</td>
										<td className="reasonForReturn">{item.returnReason}</td>
										<td>{item.lineStatus}</td>
									</tr>
								})}
							</tbody>
			      		</table>
						{self.state.showNoFile ? <p className="bold red">No Files </p>: ''}
						  {self.state.fileForCurrSerial.length > 0 ? self.state.fileForCurrSerial.map((fileObj, index) => {
        					const filename = Object.keys(fileObj)[0];
        					const item = fileObj[filename];
							return (
							<div key={index}>
								<a href={item} target="_blank">
								{filename}
								</a>
							</div>
							);
      					}): ''}
					</div>
				</div>}
				{orderDetails && <div className='d-block d-sm-none m-3'>
					<div className="orderReviewColumns">
						<div>
							<p><strong>Account #:</strong> <br/>{orderDetails && orderDetails.accountNumber}</p>
							<p>
								<strong>
									{typeOfOrder === 'credit'?"Ship to":(orderDetails.deliveryMethod === "SDS Delivery"	?"Picking Up from"
											:(orderDetails.deliveryMethod === "SDS Will Call"?"Return From"	:null))
									}
								</strong>:<br />
								{orderDetails.shippingAddress[0].addressName && <span>{orderDetails.shippingAddress[0].addressName}<br /></span>}
								<span>{orderDetails.shippingAddress[0].address1}<br /></span>
								{orderDetails.shippingAddress[0].address2 && <span>{orderDetails.shippingAddress[0].address2}<br /></span>}
								<span>{orderDetails.shippingAddress[0].city + ', ' + orderDetails.shippingAddress[0].state + ' ' + orderDetails.shippingAddress[0].zip}<br /></span>
								{orderDetails.shippingAddress[0].phone && <span>{this.props.normalizePhoneNumber(orderDetails.shippingAddress[0].phone)}<br /></span>}
							</p>
						</div>
						<div>
							{orderDetails.billingAddress && <p>
								<strong>Bill to</strong>:<br />
								{orderDetails.billingAddress.addressName && <span>{orderDetails.billingAddress.addressName}<br /></span>}
								<span>{orderDetails.billingAddress.address1}<br /></span>
								<span>{orderDetails.billingAddress.city + ', ' + orderDetails.billingAddress.state + ' ' + orderDetails.billingAddress.zip}<br /></span>
								{orderDetails.billingAddress.phone && <span>{this.props.normalizePhoneNumber(orderDetails.billingAddress.phone)}<br /></span>}
							</p>}
						</div>
						{typeOfOrder === 'return'
							?<div>
								{pickingUpByAddress && <p>
									<strong>
										{orderDetails.deliveryMethod === "SDS Delivery"
											?"Picking Up by"
											:(orderDetails.deliveryMethod === "SDS Will Call"
												?"Return To"
												:null
											)
										}
									</strong>:<br />
									{pickingUpByAddress.dockname && <span>{pickingUpByAddress.dockname}<br /></span>}
									<span>{pickingUpByAddress.dockaddr}<br /></span>
									{pickingUpByAddress.dockaddr2 && <span>{pickingUpByAddress.dockaddr2}<br /></span>}
									{pickingUpByAddress.dockaddr3 && <span>{pickingUpByAddress.dockaddr3}<br /></span>}
									<span>{pickingUpByAddress.dockcity + ', ' + pickingUpByAddress.dockst + ' ' + pickingUpByAddress.dockzip}<br /></span>
									{pickingUpByAddress.dockphone && <span>{this.props.normalizePhoneNumber(pickingUpByAddress.dockphone)}<br /></span>}
								</p>}
								<p>
								<strong>P.O.#:</strong><br/> {orderDetails.poNumber}
								</p>
							</div>
							:<div/>
						}
					</div>
					<div className="orderReviewColumns">
						<div>
							<p>
								{orderDetails.createdBy && <span><strong>Entered By:</strong><br/> {orderDetails.createdBy}<br /></span>}
								{orderDetails.orderDate && <span><strong>Entered On:</strong><br/>{this.props.formatDate(orderDetails.orderDate, 'MM/DD/YY')}<br /></span>}
							</p>
						</div>
						<div>
							<p>
								{orderDetails.deliveryPhone && <span><strong>Phone:</strong><br/>{this.props.normalizePhoneNumber(orderDetails.deliveryPhone)}<br /></span>}
								{typeOfOrder === 'return' && orderDetails.deliveryInstructions && <span><strong>Instructions:</strong><br/> {orderDetails.deliveryInstructions}<br /></span>}
							</p>
						</div>
						<div />
					</div>
					<button className='d-block d-sm-nonem p-2'>
						<a className="noUnderline bold uppercase px-2" style={{color:"#fff", paddingTop:"1rem", fontSize:"15px"}} onClick={this.handlePrint.bind(this)} href="">Print Return/Credit Details</a>
					</button>
					<div className="captionAboveTable">
						<div>
							<div className="bold">{`ORIGINAL CSO ORDER NUMBER : `}{orderDetails.originalOrderNumber}</div>
						</div>
					</div>
					{orderDetails.items.map((item, index) => {
									let quantity = item.quantity;
									let price = item.price;
									let serialNumber = typeOfOrder === 'credit'? item.userItemDescription: (item.serialNumber || item.userItemDescription);
									if(self.getLineType(item.lineType) === 'Return' || self.getLineType(item.lineType) === 'Credit') {
										quantity *= -1;
										price *= -1;
									}
									return  <div className="accordion accordion-borderless" id={`accordionViewRequest2${index}`}  key={index}>
									<div>
									<h2 className="accordion-header" id={`flush-ViewRequest2${index}`}>
									<button className="accordion-button mobileAccButton" type="button" data-bs-toggle="collapse"
										 data-bs-target={`#flush-collapseViewRequest2${index}`} aria-expanded="true" 
										 aria-controls={`flush-collapseViewRequest2${index}`}>
											{`PRODUCT `} {item.item}<br/>
										</button>
										</h2>
										<div id={`flush-collapseViewRequest2${index}`} className="accordion-collapse collapse show" 
										aria-labelledby={`flush-ViewRequest2${index}`}>
										<table className='orderTable'>
											<tbody>
												<tr className='border-bottom'>
													<td className='p-3 fw-bold'>CREDIT REQUEST QUANTITY </td>
													<td className="quantityToReturn"><span>{quantity}</span></td>
												</tr>
												<tr>
													<td className='p-3 fw-bold'>SERIAL NUMBER(S)</td>
													<td className="serialNumbers">
														{''}
													</td>
												</tr>
												{serialNumber && serialNumber !== '' && serialNumber !== 'NA' && serialNumber.split(' ').map((ser, serIndex)=>{
														return <tr className='border-bottom'>
																<td className='px-3'> {ser}</td>
																<td colSpan={2}>{self.getLineType(item.lineType) === 'Return' || self.getLineType(item.lineType) === 'Credit'? 
																	<div style={{paddingTop:"10%"}}>
																				<div>
																					<input key={index} 
																					style={{  textDecoration:"underline", color:"#0d6efd", border:'none' }} 
																					value='Open Photo(s)' 
																					onClick={() => this.handleOpenFiles(orderDetails.accountNumber, orderDetails.originalOrderNumber, item.item, ser, typeOfOrder)}/> 
																				</div>
																				<div>
																				{self.state.showNoFile ? <p className="bold red">No Files </p>: ''}
																				{self.state.fileForCurrSerial.length > 0 ? self.state.fileForCurrSerial.map((fileObj, index) => {
																					const filename = Object.keys(fileObj)[0];
																					const item = fileObj[filename];
																					return (
																					<div key={index}>
																						<a href={item} target="_blank">
																						{this.state.serState == ser?filename:''}
																						</a>
																					</div>
																					);
																				}): ''}
																				</div>
																				<div>
																					<label style={{ textDecoration:"underline", color:"#0d6efd"}}>
																					{`Add Photo(s)`}
																						<div style={{display:"none"}}>
																							<input accept="image/jpeg,image/pjpeg,image/gif,image/png,image/bmp,image/x-windows-bmp" type="file" 
																							multiple placeholder='Upload Image' onChange={(event)=>this.handleFileChange(item.item, ser, index, item.lineType, event)} />
																						</div>
																					</label>
																					{((item && item.fileUploadSerialErrors&& item.fileUploadSerialErrors.get(ser) !== 'File is uploaded successfully.' ) && this.state.showRequestReturnFileWarningDialog)
																						?<RequestReturnFileWarningDialog content ={item.fileUploadSerialErrors.get(ser)} handleDialog={this.handleDialog.bind(this)} showDialog={true}/>
																						:null
																					}
																					{((item && item.fileUploadSerialErrors&& item.fileUploadSerialErrors.get(ser) === 'File is uploaded successfully.' ) && this.state.fileUploaded)
																						?<RequestReturnFileWarningDialog content ={"File is uploaded successfully"} success={true} handleDialog={this.handleDialog.bind(this)} showDialog={true}/>
																						:null
																					}
																				</div>
																	</div>
																: null}
																</td>
													    	</tr> 
													})}
												<tr className='border-bottom'>
													<td className='p-3 fw-bold'>LINE TYPE</td>
													<td className="returnType">{self.getLineType(item.lineType)}</td>
												</tr>
												<tr className='border-bottom'>
													<td className='p-3 fw-bold'>ORIGINAL INVOICE #</td>
													<td className="originalInvoiceNumber"><a href="" onClick={this.getInvoiceDocument.bind(this, item.originalInvoiceNumber)}>{item.originalInvoiceNumber}</a></td>
												</tr>
												<tr className='border-bottom'>
													<td className='p-3 fw-bold'>PRICE</td>
													<td className="returnType">{self.formatMoney(price, 2, ".", ",", false, "$")}</td>
												</tr>
												<tr className='border-bottom'>
													<td className='p-3 fw-bold'>REASON</td>
													<td className="reasonForReturn">{item.returnReason}</td>
												</tr>
												<tr>
													<td className='p-3 fw-bold'>STATUS</td>
													<td>{item.lineStatus}</td>
												</tr>
											</tbody>
										</table>
									</div>
									</div>
								</div>
					})}
				</div>}
				{this.state.showGenericOverlayDialog?<GenericOverlayDialog genericDialogHeading={this.state.genericDialogHeading} genericDialogText={this.state.genericDialogText} buttons="ok" flag="GenericOverlayDialog" handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
			</div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	printRequestOrderDetails: (payload, callback) => dispatch(printRequestOrderDetails(payload, callback)),
	getInvoicePDF: (queryStringParams, callback) => dispatch(getInvoicePDF(queryStringParams, callback)),
	validateWarehouseCode: (payload, callback) => dispatch(validateWarehouseCode(payload, callback)),
	getFiles: (payload, callback) => dispatch(getFiles(payload, callback)),
});

ViewReturnOrderDetails = connect(mapStateToProps, mapDispatchToProps)(ViewReturnOrderDetails);
export default ViewReturnOrderDetails;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Order/viewRequestsOrderDetails.js